import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgxAimStationAddOnsClass } from './ngx-aim-station-add-ons.class';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { InputNumberModule } from 'primeng/inputnumber';
import { CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'ngx-aim-station-add-ons',
  standalone: true,
  imports: [Button, RouterLink, InputNumberModule, CurrencyPipe, FormsModule, ProgressSpinnerModule],
  templateUrl: './ngx-aim-station-add-ons.component.html',
  styleUrl: './ngx-aim-station-add-ons.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimStationAddOnsComponent extends NgxAimStationAddOnsClass implements OnInit { 
  ngOnInit() {
    this.init();
  }
}
